import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { faClipboardList } from '@fortawesome/pro-regular-svg-icons/faClipboardList';
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'antd';
import { AssetTypesSearchForm } from 'pos-client/components/assetsTypes/AssetTypesSearchForm.tsx';
import { AssetTypesModal } from 'pos-client/components/assetsTypes/Modals/AssetTypesModal.tsx';
import { PosCard } from 'pos-client/components/shared/Display/Card/PosCard.tsx';
import { PosPageContent } from 'pos-client/layouts/page/PosPageContent.tsx';

export const AssetTypesPage = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <PosPageContent>
        <PosCard
          headerProps={{
            title: t('assets.assetTypesManagement'),
            icon: faClipboardList,
            description: t('assets.assetTypePageDescription'),
            action: (
              <Button
                type="primary"
                icon={<FontAwesomeIcon icon={faPlus} />}
                onClick={showModal}
              >
                {t('assets.createAssetType')}
              </Button>
            ),
          }}
        >
          <AssetTypesSearchForm />
        </PosCard>
      </PosPageContent>
      {isModalOpen && (
        <AssetTypesModal handleCancel={handleCancel} handleOk={handleOk} />
      )}
    </>
  );
};
